/**
 * `78324` — *and only if {dropdown} {contains …} {these labels}*, over label **indexes**:
 * `one` = intersection non-empty · `only` = the cell's set equals the configured set ·
 * `all` = configured set ⊆ cell's set. An empty cell passes none of the three.
 *
 * The column is resolved **by id only** — three of the dropdown columns on this account are
 * called `text61`, `text7` and `status9`, so nothing may infer a type from an id or a title.
 */
import { z } from 'zod';
import { defineCondition } from '../block.js';
import { columnRefSchema, dropdownConditionSchema, labelIndexesOf, labelValueListSchema, isAnyValue } from '../values.js';
export const dropdownContainsParams = z.object({
    dropdownColumnId: columnRefSchema,
    dropdownColumnValuesCondition: dropdownConditionSchema,
    dropdownColumnValues: labelValueListSchema,
});
export const dropdownContainsCondition = defineCondition({
    id: '78324',
    kind: 'condition',
    app: 'monday',
    sentencePartial: 'and only if {dropdown, dropdownColumnId} {contains all, dropdownColumnValuesCondition} {these labels, dropdownColumnValues}',
    paramsSchema: dropdownContainsParams,
    requiredColumnTypes: ['dropdown'],
    references: (params) => [
        { kind: 'column', id: params.dropdownColumnId.columnId, invalid: params.dropdownColumnId.invalid },
    ],
    async evaluate(context, params) {
        if (context.itemId === null)
            return false;
        const value = await context.services.getCellValue(context.itemId, params.dropdownColumnId.columnId);
        const cell = new Set(labelIndexesOf(value));
        const wanted = params.dropdownColumnValues.filter((entry) => !isAnyValue(entry)).map((entry) => entry.index);
        if (cell.size === 0)
            return false;
        switch (params.dropdownColumnValuesCondition) {
            case 'one':
                return wanted.some((index) => cell.has(index));
            case 'only':
                return cell.size === wanted.length && wanted.every((index) => cell.has(index));
            case 'all':
            default:
                return wanted.every((index) => cell.has(index));
        }
    },
});
//# sourceMappingURL=78324.js.map